module.exports = __webpack_public_path__ + "static/img/zt2_banner_two.fdb631d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/zt2_banner_two.jpg
// module id = A+Xz
// module chunks = 171